import moment from 'moment';

import Composition from 'models/composition';
import CustomerView from 'models/location/customer_view';
import { findTaskThreadReplyComposition } from 'actions/composition/lib/composer_compositions';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';
import { defaultFromForInbox } from 'actions/composition/create_email_composition';
import nextDay from 'scripts/lib/next_day';
import TaskThreadReplyCompositionContent from 'models/composition/task_thread_reply_composition_content';

// Unlike CreateComposition this never activates the draft. A task has at most one reply draft, so none
// is created until the saved drafts have loaded.
export default class CreateTaskThreadReplyComposition {
  constructor(context) {
    this.context = context;
  }

  run({ taskId, conversationId, from, to, cc, subject, taskDueAt, taskRoutingGroupId }) {
    const currentLocation = this.context.stores.currentLocation.get();
    if (!(currentLocation instanceof CustomerView)) {
      return;
    }

    const compositions = getCompositionsStore(this.context);
    if (!compositions || compositions.isLoading() || findTaskThreadReplyComposition(compositions, taskId)) {
      return;
    }

    // A task with no email yet has no address to answer from, so its first email leaves from its inbox.
    const content = new TaskThreadReplyCompositionContent({
      taskId,
      from: from || defaultFromForInbox(this.context, taskRoutingGroupId),
      to: (to || []).join(', '),
      cc: (cc || []).join(', '),
      subject: subject || '',
      dueAt: followUpDueAt(taskDueAt),
    });
    const customerId = currentLocation.customerId;
    const composition = Composition.create({ content, conversationId, customerId });
    compositions.add(composition);
    this.context.stores.localCompositions.set(customerId, composition);
  }
}

// The send sets the task's due date, so the task's own follow-up carries over unless it has passed.
function followUpDueAt(taskDueAt) {
  return taskDueAt && moment(taskDueAt).isAfter() ? taskDueAt : nextDay();
}
